import React from "react";
import { Avatar, Tooltip } from "antd";

const ChatThread = ({ notes, currentUserId }) => {
  if (!Array.isArray(notes)) return null;

  const formatted = (str) => {
    return new Date(str).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  };

  return (
    <div
      style={{
        flex: 1,
        padding: "20px",
        overflowY: "auto",
        backgroundColor: "#fafafa",
      }}
    >
      {notes.map((note) => {
        const isCurrentUser = String(note.senderId?._id || note.senderId) === String(currentUserId);
        const senderName = note.senderId?.name || "User";

        return (
          <div
            key={note._id}
            style={{
              marginBottom: "20px",
              display: "flex",
              justifyContent: isCurrentUser ? "flex-end" : "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: isCurrentUser ? "row-reverse" : "row",
                gap: "10px",
                alignItems: "flex-end",
                maxWidth: "80%",
              }}
            >
              <Tooltip title={isCurrentUser ? "You" : senderName}>
                <Avatar style={{ backgroundColor: isCurrentUser ? "#4a90e2" : "#999" }}>
                  {(isCurrentUser ? "Y" : senderName.charAt(0).toUpperCase())}
                </Avatar>
              </Tooltip>

              <div style={{ display: "flex", flexDirection: "column", alignItems: isCurrentUser ? "flex-end" : "flex-start" }}>
                <div
                  style={{
                    backgroundColor: isCurrentUser ? "#4a90e2" : "#e5e5ea",
                    color: isCurrentUser ? "white" : "#333",
                    padding: "12px 16px",
                    borderRadius: "18px",
                    maxWidth: "400px",
                    wordWrap: "break-word",
                    fontSize: "14px",
                  }}
                >
                {note.noteType === "chat" && (
                  <>
                    {note.note && (
                      <div>
                        {note.note.split(/(\s+)/).map((part, idx) => {
                          const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/i;
                          if (urlPattern.test(part)) {
                            const url = part.startsWith("http") ? part : `https://${part}`;
                            return (
                              <a
                                key={idx}
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "white", textDecoration: "underline" }}
                              >
                                {part}
                              </a>
                            );
                          }
                          return <React.Fragment key={idx}>{part}</React.Fragment>;
                        })}
                      </div>
                    )}
                    {note.appointmentImage && (
                      <div style={{ marginTop: "10px" }}>
                        <img
                          src={note.appointmentImage}
                          alt="attachment"
                          style={{
                            width: "150px",
                            height: "auto",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                          }}
                        />
                      </div>
                    )}
                  </>
                )}

                  {note.noteType === "serial_image" && (
                    <>
                      <div><strong>Serial #: </strong>{note.serialNumber}</div>
                      {note.serialImage && (
                        <div style={{ marginTop: "10px" }}>
                          <img
                            src={note.serialImage}
                            alt="serial"
                            style={{
                              width: "150px",
                              height: "auto",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div
                  style={{
                    fontSize: "12px",
                    color: "#888",
                    marginTop: "5px",
                  }}
                >
                  {formatted(note.createdAt)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ChatThread;

